import { IContractDetailDTO } from '../../entities';
import { IAmounts } from './IAmounts';
import { injectable } from 'inversify';
import { IBarcodeParserStrategy } from './IBarcodeParserStrategy';
import * as _ from 'lodash';

@injectable()
export class PriceStrategy implements IBarcodeParserStrategy {
    parseBarcode(
        readBarcode: string,
        { kommastellen: decimalPlaces, preis = 0 }: IContractDetailDTO,
        detailBarcode?: string,
        factor?: number
    ): IAmounts | null {
        const matchPriceStrategy = /0*(\d+)P.*/.exec(detailBarcode || '');

        if (!matchPriceStrategy) {
            return null;
        }

        const productCode = matchPriceStrategy[1];

        if (!readBarcode.startsWith(productCode)) {
            return null;
        }
        
        const scannedRappenPrice = parseInt(readBarcode.slice(productCode.length, -1), 10);
        const scannedPrice = scannedRappenPrice / 100 || 0;
        const pricePerUnit = factor != undefined ? factor : preis;
        const productWeight = pricePerUnit > 0 ? scannedPrice / pricePerUnit : 0;

        return {
            amount: _.round(productWeight, decimalPlaces),
            factor: 1,
        };
    }
}
